import React from 'react';
import WidgetReference from './WidgetReference';

export default function BonusSpendingThreshold() {
  return (
    <>
      <WidgetReference guideId="bonus-spending-threshold" />
    <iframe
      src="https://scribehow.com/o/_ygSvBcHTUyj_X5hGoV2bw/viewer/Getting_Started__Xd3nTzzDTeODHxvOPjEF9w?scrollToActionId=a5d8950c"
      height="640"
      title="Bonus Spending Threshold"
      allowFullScreen
    />
    </>
  );
}
